module.exports = __webpack_public_path__ + "static/img/7.02a0a0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting824/images/7.png
// module id = Zh/3
// module chunks = 4